import ServerInfo from "@arcgis/core/identity/ServerInfo.js";
import esriId from "@arcgis/core/identity/IdentityManager.js";

import { CommonService } from "./common/commonService";
import { ServicesConfig } from "./servicesConfig";


const API_URL = "/"

export class SecurityService {


    static authenticate = (username, password) => {
        var bean = { "user": username, "password": password };
        return CommonService.post(ServicesConfig.getBaseUrl() + "/auth/login", bean);
    }

    static getUser = (token) => {
        let url = ServicesConfig.getBaseUrl() + "/auth/user";
        return CommonService.getWithToken(url, token);
    }

    /**
     * Servicio para generar el token para acceder a servicios privados
     */
    static getTokenArcgisServer = async (idCapa) => {
        let token = null;

        try {
            await CommonService.get(ServicesConfig.getBaseUrl() + "/arcserviceauth/token/" + idCapa)
                .then(async (data) => {

                    //console.log("datos", data.srvSecsMapLayers)
                    //Solo se genera el token para las capas que tienen username y password asociados
                    if (data.srvSecsMapLayers.length > 0) {
                        const tokenServiceUrl = data.conf.url.split('rest')[0] + "tokens/generateToken"

                        let serverInfo = new ServerInfo({
                            server: data.conf.url, // URL de tu servidor de ArcGIS
                            tokenServiceUrl: tokenServiceUrl, // URL del servicio de generación de tokens
                        });

                        // Define la información del usuario (nombre de usuario y contraseña)
                        let userInfo = {
                            username: data.srvSecsMapLayers[0].username,
                            password: data.srvSecsMapLayers[0].password,
                        };

                        // Llama al método generateToken para obtener un token de autenticación
                        await esriId.generateToken(serverInfo, userInfo)
                            .then(function (tokenInfo) {
                                // El token se ha generado con éxito

                                token = tokenInfo;
                                //console.log("token", tokenInfo)

                            })
                            .catch(function (error) {
                                // Error al generar el token
                                console.error("Error al generar el token:", error);
                            });
                    }

                    //console.log('config', tokenServiceUrl)
                    return token;
                })
                .catch(e => {
                    //console.log("Datos no encontrados.", error)
                    return token;
                })
        }
        catch (e) {
            console.log("Error", e)
        }

        return token;
    }

    static getServicesCredentials = () => (
        CommonService.get(ServicesConfig.getBaseUrl() + "/sgvmap/credentials/services")
    )

}